import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

const CONFIG_PARAMS = {
  AUTH_DOMAIN: 'lili-banking.firebaseapp.com',
  DB_URL: 'https://lili-banking.firebaseio.com',
  PROJECT_ID: 'lili-banking',
  STORAGE_BUCKET: 'lili-banking.appspot.com',
  MESSAGING_SENDER_ID: '581995798349',
  APP_ID: '1:581995798349:web:a262fbb142cec5eadae104',
  MEASUREMENT_ID: 'G-S2NBQ091D1',
};

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIRE_BASE_API_KEY,
  authDomain: CONFIG_PARAMS.AUTH_DOMAIN,
  databaseURL: CONFIG_PARAMS.DB_URL,
  projectId: CONFIG_PARAMS.PROJECT_ID,
  storageBucket: CONFIG_PARAMS.STORAGE_BUCKET,
  messagingSenderId: CONFIG_PARAMS.MESSAGING_SENDER_ID,
  appId: CONFIG_PARAMS.APP_ID,
  measurementId: CONFIG_PARAMS.MEASUREMENT_ID,
};

let fireBaseInstance: any = null;

export const initFireBase = async () => {
  fireBaseInstance = await initializeApp(firebaseConfig);
};

export const getFireBaseAnalytics = async () => {
  const analyticsData = await getAnalytics(fireBaseInstance);
  const { app } = analyticsData;
  return app;
};
